import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M23.9.587a1.2 1.2 0 0 0-.5-.49C23.3 0 23.1 0 23 0h-6c-.6 0-1 .391-1 .978 0 .586.4.977 1 .977h3.6l-7.1 6.941-4.3-4.204a.98.98 0 0 0-1.4 0L.3 12.024a.93.93 0 0 0 0 1.369c.2.195.4.293.7.293s.5-.098.7-.293l6.8-6.648 4.3 4.204c.4.391 1 .391 1.4 0L22 3.324v3.52c0 .586.4.977 1 .977s1-.391 1-.978V.978c0-.098 0-.294-.1-.391"
    }, null, -1)
  ]))]))
}
export default { render: render }